import React from 'react'

import { Box, BoxProps } from '../Box'

export interface CardProps extends BoxProps {}

export const Card = ({ children, ...restProps }: CardProps) => {
  return (
    <Box border="2px" borderRadius="lg" borderColor="gray.200" bg="white" {...restProps}>
      {children}
    </Box>
  )
}

export default Card
